import { render, staticRenderFns } from "./insertSaleAddon.vue?vue&type=template&id=1f3691ec"
import script from "./insertSaleAddon.vue?vue&type=script&lang=js"
export * from "./insertSaleAddon.vue?vue&type=script&lang=js"
import style0 from "./insertSaleAddon.vue?vue&type=style&index=0&id=1f3691ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports